import { Helmet } from 'react-helmet-async';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
// components
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { Typography } from '@mui/material';

import MyTaskList from './components/MyTaskList';
import BreadCrumb from '../../components/breadcrumb/BreadCrumbNavigation';
import { isStakeholder } from '../../utils/share';
// ----------------------------------------------------------------------

export default function MyTaskPage() {
  const queryClient = new QueryClient();

  const breadcrumbs = [
    {
      label: 'Home',
      path: '/',
    },
    {
      label: 'My Task',
      path: '',
    },
  ];
  return (
    <>
      <QueryClientProvider client={queryClient}>
        <Helmet>
          <title> My Tasks </title>
        </Helmet>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          {!isStakeholder() && <BreadCrumb breadcrumbs={breadcrumbs} />}
          {isStakeholder() && (
            <Typography variant="h6" gutterBottom ml={2}>
              Issues
            </Typography>
          )}
          <MyTaskList />
        </LocalizationProvider>
      </QueryClientProvider>
    </>
  );
}
